module.exports = __webpack_public_path__ + "img/電気回路_6_9_5.c19134f1.png";